import { render, staticRenderFns } from "./RenovateOrDemolish.vue?vue&type=template&id=20713ccb"
import script from "./RenovateOrDemolish.vue?vue&type=script&setup=true&lang=js"
export * from "./RenovateOrDemolish.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports